import React from 'react';
import { useSystemUserDetails } from '../hooks/use-system-user-details.js';
import SystemUserDetailsPageView from './system-user-details-page-view.jsx';

function SystemUserDetailsPageContainer() {
  const state = useSystemUserDetails();
  return <SystemUserDetailsPageView {...state} />;
}

export default SystemUserDetailsPageContainer;
